import { render } from "./ThePageWrapper.vue?vue&type=template&id=510766e3&bindings={\"pinned\":\"data\",\"setSideBar\":\"options\",\"showSidebar\":\"options\",\"hideSidebar\":\"options\"}"
import script from "./ThePageWrapper.vue?vue&type=script&lang=js"
export * from "./ThePageWrapper.vue?vue&type=script&lang=js"

import "./ThePageWrapper.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script